export default "__VITE_ASSET__5NQIGl7k__"